/**
 * Variant option tooltips – click-to-open modal behaviour.
 * Icon + bubble + modal source markup is rendered server-side by
 * snippets/variant-tooltip-icon.liquid; this only wires up the modal open/close.
 * Desktop hover-preview is pure CSS (see variant-tooltips.css).
 */
(function () {
  function createModal(html, modalAriaLabel, closeAriaLabel) {
    const modal = document.createElement('div');
    modal.className = 'variant-tooltip-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', modalAriaLabel);

    const modalContent = document.createElement('div');
    modalContent.className = 'variant-tooltip-modal-content';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'variant-tooltip-modal-close';
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', closeAriaLabel);
    closeBtn.textContent = '×';

    const modalText = document.createElement('div');
    modalText.className = 'variant-tooltip-modal-text';
    modalText.innerHTML = html;

    modalContent.appendChild(closeBtn);
    modalContent.appendChild(modalText);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    function close() {
      modal.classList.remove('is-open');
    }
    closeBtn.addEventListener('click', close);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) close();
    });

    return modal;
  }

  function init() {
    document.querySelectorAll('.variant-tooltip-wrapper').forEach(function (wrapper) {
      const icon = wrapper.querySelector('.variant-tooltip-icon');
      const cta = wrapper.querySelector('.variant-tooltip-cta');
      const source = wrapper.querySelector('.variant-tooltip-modal-source');
      if (!icon || !source) return;

      const modalAriaLabel = wrapper.dataset.modalAriaLabel || 'Info';
      const closeAriaLabel = wrapper.dataset.closeAriaLabel || 'Close';
      const modal = createModal(source.innerHTML, modalAriaLabel, closeAriaLabel);

      function openModal(e) {
        e.preventDefault();
        e.stopPropagation();
        modal.classList.add('is-open');
      }

      function openModalOnKey(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          modal.classList.add('is-open');
        }
      }

      icon.addEventListener('click', openModal);
      icon.addEventListener('keydown', openModalOnKey);

      if (cta) {
        cta.addEventListener('click', openModal);
        cta.addEventListener('keydown', openModalOnKey);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
